<template>
  <div class="automations-tab">
    <!-- Loading -->
    <div v-if="loading" class="automations-tab__loading">
      <Loading :loading="true" loadingText="Loading automations..." />
    </div>

    <!-- Error -->
    <div v-else-if="error" class="automations-tab__error">
      <div class="automations-tab__error-box">
        <svg class="automations-tab__error-icon" width="20" height="20" viewBox="0 0 20 20" fill="currentColor">
          <path fill-rule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zM8.707 7.293a1 1 0 00-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 101.414 1.414L10 11.414l1.293 1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1 1 0 00-1.414-1.414L10 8.586 8.707 7.293z" clip-rule="evenodd" />
        </svg>
        <span>{{ error }}</span>
        <button class="automations-tab__retry" @click="retry">Retry</button>
      </div>
    </div>

    <!-- Empty -->
    <div v-else-if="items.length === 0 && completedItems.length === 0 && approvalItems.length === 0 && approvedItems.length === 0" class="automations-tab__empty">
      <p>No automations yet</p>
    </div>

    <!-- Content -->
    <template v-else>
      <!-- Pending Approvals section -->
      <div v-if="approvalItems.length > 0" class="automations-tab__approvals-section">
        <div class="automations-tab__approvals-header">
          <svg width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M11.4375 8.625H8.4375C8.28832 8.625 8.14524 8.56574 8.03975 8.46025C7.93426 8.35476 7.875 8.21168 7.875 8.0625V3.5625C7.875 3.41332 7.93426 3.27024 8.03975 3.16475C8.14524 3.05926 8.28832 3 8.4375 3C8.58668 3 8.72976 3.05926 8.83525 3.16475C8.94074 3.27024 9 3.41332 9 3.5625V7.5H11.4375C11.5867 7.5 11.7298 7.55926 11.8352 7.66475C11.9407 7.77024 12 7.91332 12 8.0625C12 8.21168 11.9407 8.35476 11.8352 8.46025C11.7298 8.56574 11.5867 8.625 11.4375 8.625ZM9 0C4.8585 0 1.5 3.3585 1.5 7.5V7.527C1.623 7.509 1.74825 7.5 1.87575 7.5H4.87575C5.57194 7.5 6.23962 7.77656 6.73191 8.26884C7.22419 8.76113 7.50075 9.42881 7.50075 10.125V14.625C7.50075 14.7 7.49775 14.7745 7.49175 14.8485C7.97975 14.9485 8.4825 14.999 9 15C13.1415 15 16.5 11.6415 16.5 7.5C16.5 3.3585 13.1415 0 9 0ZM0 10.125C0 9.62772 0.197544 9.15081 0.549175 8.79918C0.900805 8.44754 1.37772 8.25 1.875 8.25H4.875C5.37228 8.25 5.84919 8.44754 6.20083 8.79918C6.55246 9.15081 6.75 9.62772 6.75 10.125V14.625C6.75 15.1223 6.55246 15.5992 6.20083 15.9508C5.84919 16.3025 5.37228 16.5 4.875 16.5H1.875C1.37772 16.5 0.900805 16.3025 0.549175 15.9508C0.197544 15.5992 0 15.1223 0 14.625V10.125ZM4.875 9.75H1.875C1.77554 9.75 1.68016 9.78951 1.60984 9.85983C1.53951 9.93016 1.5 10.0255 1.5 10.125C1.5 10.2245 1.53951 10.3198 1.60984 10.3902C1.68016 10.4605 1.77554 10.5 1.875 10.5H4.875C4.97446 10.5 5.06984 10.4605 5.14016 10.3902C5.21049 10.3198 5.25 10.2245 5.25 10.125C5.25 10.0255 5.21049 9.93016 5.14016 9.85983C5.06984 9.78951 4.97446 9.75 4.875 9.75ZM4.875 12H1.875C1.77554 12 1.68016 12.0395 1.60984 12.1098C1.53951 12.1802 1.5 12.2755 1.5 12.375C1.5 12.4745 1.53951 12.5698 1.60984 12.6402C1.68016 12.7105 1.77554 12.75 1.875 12.75H4.875C4.97446 12.75 5.06984 12.7105 5.14016 12.6402C5.21049 12.5698 5.25 12.4745 5.25 12.375C5.25 12.2755 5.21049 12.1802 5.14016 12.1098C5.06984 12.0395 4.97446 12 4.875 12ZM4.875 14.25H1.875C1.77554 14.25 1.68016 14.2895 1.60984 14.3598C1.53951 14.4302 1.5 14.5255 1.5 14.625C1.5 14.7245 1.53951 14.8198 1.60984 14.8902C1.68016 14.9605 1.77554 15 1.875 15H4.875C4.97446 15 5.06984 14.9605 5.14016 14.8902C5.21049 14.8198 5.25 14.7245 5.25 14.625C5.25 14.5255 5.21049 14.4302 5.14016 14.3598C5.06984 14.2895 4.97446 14.25 4.875 14.25Z" fill="#EC4899"/>
          </svg>
          <span class="automations-tab__approvals-label">Pending Approval{{ approvalItems.length === 1 ? '' : 's' }}</span>
          <span class="automations-tab__approvals-count">({{ approvalItems.length }})</span>
        </div>
        <div
          v-for="(row, rowIndex) in approvalRows"
          :key="'approval-row-' + rowIndex"
          class="automations-tab__card-row"
        >
          <ApprovalCard
            v-for="card in row"
            :key="card.id"
            :item="card"
            :expanded="expandedApprovalId === card.id"
            :approving="approvalActionInFlight?.id === card.id && approvalActionInFlight?.action === 'approve'"
            :rejecting="approvalActionInFlight?.id === card.id && approvalActionInFlight?.action === 'reject'"
            @toggle-expand="toggleApprovalExpand"
            @approve="handleApprove"
            @reject="handleReject"
          />
          <div v-if="row.length === 1" class="automations-tab__card-spacer" />
        </div>
      </div>

      <!-- Completed Approvals section -->
      <div v-if="approvedItems.length > 0" class="automations-tab__approved-section">
        <div class="automations-tab__approved-header">
          <svg width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M11.4375 8.625H8.4375C8.28832 8.625 8.14524 8.56574 8.03975 8.46025C7.93426 8.35476 7.875 8.21168 7.875 8.0625V3.5625C7.875 3.41332 7.93426 3.27024 8.03975 3.16475C8.14524 3.05926 8.28832 3 8.4375 3C8.58668 3 8.72976 3.05926 8.83525 3.16475C8.94074 3.27024 9 3.41332 9 3.5625V7.5H11.4375C11.5867 7.5 11.7298 7.55926 11.8352 7.66475C11.9407 7.77024 12 7.91332 12 8.0625C12 8.21168 11.9407 8.35476 11.8352 8.46025C11.7298 8.56574 11.5867 8.625 11.4375 8.625ZM9 0C4.8585 0 1.5 3.3585 1.5 7.5V7.527C1.623 7.509 1.74825 7.5 1.87575 7.5H4.87575C5.57194 7.5 6.23962 7.77656 6.73191 8.26884C7.22419 8.76113 7.50075 9.42881 7.50075 10.125V14.625C7.50075 14.7 7.49775 14.7745 7.49175 14.8485C7.97975 14.9485 8.4825 14.999 9 15C13.1415 15 16.5 11.6415 16.5 7.5C16.5 3.3585 13.1415 0 9 0ZM0 10.125C0 9.62772 0.197544 9.15081 0.549175 8.79918C0.900805 8.44754 1.37772 8.25 1.875 8.25H4.875C5.37228 8.25 5.84919 8.44754 6.20083 8.79918C6.55246 9.15081 6.75 9.62772 6.75 10.125V14.625C6.75 15.1223 6.55246 15.5992 6.20083 15.9508C5.84919 16.3025 5.37228 16.5 4.875 16.5H1.875C1.37772 16.5 0.900805 16.3025 0.549175 15.9508C0.197544 15.5992 0 15.1223 0 14.625V10.125ZM4.875 9.75H1.875C1.77554 9.75 1.68016 9.78951 1.60984 9.85983C1.53951 9.93016 1.5 10.0255 1.5 10.125C1.5 10.2245 1.53951 10.3198 1.60984 10.3902C1.68016 10.4605 1.77554 10.5 1.875 10.5H4.875C4.97446 10.5 5.06984 10.4605 5.14016 10.3902C5.21049 10.3198 5.25 10.2245 5.25 10.125C5.25 10.0255 5.21049 9.93016 5.14016 9.85983C5.06984 9.78951 4.97446 9.75 4.875 9.75ZM4.875 12H1.875C1.77554 12 1.68016 12.0395 1.60984 12.1098C1.53951 12.1802 1.5 12.2755 1.5 12.375C1.5 12.4745 1.53951 12.5698 1.60984 12.6402C1.68016 12.7105 1.77554 12.75 1.875 12.75H4.875C4.97446 12.75 5.06984 12.7105 5.14016 12.6402C5.21049 12.5698 5.25 12.4745 5.25 12.375C5.25 12.2755 5.21049 12.1802 5.14016 12.1098C5.06984 12.0395 4.97446 12 4.875 12ZM4.875 14.25H1.875C1.77554 14.25 1.68016 14.2895 1.60984 14.3598C1.53951 14.4302 1.5 14.5255 1.5 14.625C1.5 14.7245 1.53951 14.8198 1.60984 14.8902C1.68016 14.9605 1.77554 15 1.875 15H4.875C4.97446 15 5.06984 14.9605 5.14016 14.8902C5.21049 14.8198 5.25 14.7245 5.25 14.625C5.25 14.5255 5.21049 14.4302 5.14016 14.3598C5.06984 14.2895 4.97446 14.25 4.875 14.25Z" fill="#EC4899"/>
          </svg>
          <span class="automations-tab__approved-label">Completed Approval{{ approvedItems.length === 1 ? '' : 's' }}</span>
          <span class="automations-tab__approved-count">({{ approvedItems.length }})</span>
        </div>
        <div
          v-for="(row, rowIndex) in approvedRows"
          :key="'approved-row-' + rowIndex"
          class="automations-tab__card-row"
        >
          <ApprovalCard
            v-for="card in row"
            :key="card.id"
            :item="card"
            :expanded="expandedApprovalId === card.id"
            @toggle-expand="toggleApprovalExpand"
          />
          <div v-if="row.length === 1" class="automations-tab__card-spacer" />
        </div>
      </div>

      <!-- Active items -->
      <div v-if="items.length > 0" class="automations-tab__active-section">
        <div
          v-for="(row, rowIndex) in activeRows"
          :key="'row-' + rowIndex"
          class="automations-tab__card-row"
        >
          <AutomationsCard
            v-for="card in row"
            :key="card.id"
            :item="card"
            :variant="card.priority"
            :expanded="expandedCardId === card.id"
            :messages-loading="messagesLoading"
            :sending-message="sendingMessage"
            @toggle-expand="toggleExpand"
            @send-message="handleSendMessage"
            @archive="handleArchive"
          />
          <!-- Spacer if odd number in last row -->
          <div v-if="row.length === 1" class="automations-tab__card-spacer" />
        </div>
      </div>

      <!-- Completed section -->
      <div v-if="completedItems.length > 0" class="automations-tab__completed-section">
        <div class="automations-tab__completed-header">
          <div class="automations-tab__completed-title">
            <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M16.5 3.885L7.9425 12.45L4.7625 9.27L5.82 8.2125L7.9425 10.335L15.4425 2.835L16.5 3.885ZM14.8425 7.665C14.94 8.0925 15 8.5425 15 9C15 12.315 12.315 15 9 15C5.685 15 3 12.315 3 9C3 5.685 5.685 3 9 3C10.185 3 11.28 3.345 12.21 3.9375L13.29 2.8575C12.075 2.0025 10.5975 1.5 9 1.5C4.86 1.5 1.5 4.86 1.5 9C1.5 13.14 4.86 16.5 9 16.5C13.14 16.5 16.5 13.14 16.5 9C16.5 8.1075 16.335 7.2525 16.05 6.4575L14.8425 7.665Z" fill="#588B8B"/>
            </svg>
            <span class="automations-tab__completed-label">Completed</span>
            <span class="automations-tab__completed-sublabel">(agent session ended)</span>
          </div>
          <span class="automations-tab__auto-archived">Auto-archived daily</span>
        </div>

        <div
          v-for="(row, rowIndex) in completedRows"
          :key="'completed-row-' + rowIndex"
          class="automations-tab__card-row"
        >
          <AutomationsCard
            v-for="card in row"
            :key="card.id"
            :item="card"
            variant="complete"
          />
          <div v-if="row.length === 1" class="automations-tab__card-spacer" />
        </div>
      </div>
    </template>
    <!-- Archive Confirmation Dialog -->
    <el-dialog
      v-model="archiveDialogVisible"
      :show-close="false"
      modal-class="archive-confirm-dialog"
      width="540px"
      append-to-body
      :close-on-click-modal="!archiving"
      @close="cancelArchive"
    >
      <div class="archive-dialog">
        <div class="archive-dialog__header">
          <div class="archive-dialog__header-content">
            <svg class="archive-dialog__header-icon" width="24" height="24" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M13.5 0H1.5C0.75 0 0 0.675 0 1.5V3.7575C0 4.2975 0.3225 4.7625 0.75 5.025V13.5C0.75 14.325 1.575 15 2.25 15H12.75C13.425 15 14.25 14.325 14.25 13.5V5.025C14.6775 4.7625 15 4.2975 15 3.7575V1.5C15 0.675 14.25 0 13.5 0ZM12.75 13.5H2.25V5.25H12.75V13.5ZM13.5 3.75H1.5V1.5H13.5V3.75Z" fill="#d10000"/>
              <path d="M9.75 7.5H5.25V9H9.75V7.5Z" fill="#d10000"/>
            </svg>
            <h1 class="archive-dialog__title">Archive Session?</h1>
          </div>
          <button class="archive-dialog__close-btn" :disabled="archiving" @click="cancelArchive">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M7 7L17 17M17 7L7 17" stroke="#d10000" stroke-width="2" stroke-linecap="round"/>
            </svg>
          </button>
        </div>
        <div class="archive-dialog__content">
          <p class="archive-dialog__message">
            Are you sure you want to archive <strong>{{ archiveItemName }}</strong>? The associated workflow will be stopped.
          </p>
        </div>
        <div class="archive-dialog__footer">
          <div class="archive-dialog__actions">
            <button class="archive-dialog__btn archive-dialog__btn--cancel" :disabled="archiving" @click="cancelArchive">Cancel</button>
            <button class="archive-dialog__btn archive-dialog__btn--confirm" :disabled="archiving" @click="confirmArchive">
              {{ archiving ? 'Archiving...' : 'Archive' }}
            </button>
          </div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import AutomationsCard from './AutomationsCard.vue';
import ApprovalCard from './ApprovalCard.vue';
import Loading from '@/NewLibrary/Loading/Loading.vue';

export default {
  name: 'AutomationsTab',
  components: { AutomationsCard, ApprovalCard, Loading },
  data() {
    return {
      archiveDialogVisible: false,
      archiveSessionId: null,
      archiving: false,
      expandedApprovalId: null,
    };
  },
  computed: {
    ...mapState('notifications', {
      items: state => state.automations.items,
      completedItems: state => state.automations.completedItems,
      loading: state => state.automations.loading,
      error: state => state.automations.error,
      expandedCardId: state => state.automations.expandedCardId,
      messagesLoading: state => state.automations.messagesLoading,
      sendingMessage: state => state.automations.sendingMessage,
      approvalItems: state => state.approvals.items,
      approvedItems: state => state.approvals.approvedItems,
      approvalsLoading: state => state.approvals.loading,
      approvalActionInFlight: state => state.approvals.actionInFlight,
    }),
    activeRows() {
      return this.chunkArray(this.items, 2);
    },
    completedRows() {
      return this.chunkArray(this.completedItems, 2);
    },
    approvalRows() {
      return this.chunkArray(this.approvalItems, 2);
    },
    approvedRows() {
      return this.chunkArray(this.approvedItems, 2);
    },
    archiveItemName() {
      if (!this.archiveSessionId) return '';
      const item = this.items.find(i => i.id === this.archiveSessionId);
      return item?.title || 'this session';
    },
  },
  methods: {
    chunkArray(arr, size) {
      const result = [];
      for (let i = 0; i < arr.length; i += size) {
        result.push(arr.slice(i, i + size));
      }
      return result;
    },
    toggleExpand(id) {
      const wasExpanded = this.expandedCardId === id;
      this.$store.commit('notifications/SET_EXPANDED_CARD', id);
      if (!wasExpanded) {
        const item = this.items.find(i => i.id === id);
        if (item && !item.chatHistory) {
          this.$store.dispatch('notifications/fetchSessionMessages', id);
        }
      }
    },
    handleSendMessage({ id, text }) {
      this.$store.dispatch('notifications/sendAutomationMessage', {
        sessionId: id,
        content: text,
      });
    },
    handleArchive(id) {
      this.archiveSessionId = id;
      this.archiveDialogVisible = true;
    },
    async confirmArchive() {
      if (!this.archiveSessionId) return;
      this.archiving = true;
      try {
        await this.$store.dispatch('notifications/archiveAutomationSession', this.archiveSessionId);
      } finally {
        this.archiving = false;
        this.archiveDialogVisible = false;
        this.archiveSessionId = null;
      }
    },
    cancelArchive() {
      if (this.archiving) return;
      this.archiveDialogVisible = false;
      this.archiveSessionId = null;
    },
    toggleApprovalExpand(id) {
      this.expandedApprovalId = this.expandedApprovalId === id ? null : id;
    },
    handleApprove(approvalExecutionId) {
      this.expandedApprovalId = null;
      this.$store.dispatch('notifications/approveApproval', { approvalExecutionId });
    },
    handleReject(approvalExecutionId) {
      this.$store.dispatch('notifications/rejectApproval', { approvalExecutionId });
    },
    retry() {
      this.$store.dispatch('notifications/fetchAutomations');
      this.$store.dispatch('notifications/fetchApprovals');
    },
  },
};
</script>

<style scoped>
.automations-tab {
  display: flex;
  flex-direction: column;
  gap: 12px;
  overflow-x: hidden;
  overflow-y: auto;
  flex: 1;
  min-height: 0;
  scrollbar-width: thin;
  scrollbar-color: #c1c1c1 transparent;
}

.automations-tab::-webkit-scrollbar {
  width: 4px;
}

.automations-tab::-webkit-scrollbar-track {
  background: transparent;
}

.automations-tab::-webkit-scrollbar-thumb {
  background: #c1c1c1;
  border-radius: 2px;
}

.automations-tab::-webkit-scrollbar-thumb:hover {
  background: #a8a8a8;
}

.automations-tab__loading,
.automations-tab__empty {
  display: flex;
  align-items: center;
  justify-content: center;
  flex: 1;
  padding: 40px 0;
  color: #999;
  font-family: Inter, sans-serif;
  font-size: 14px;
}

.automations-tab__error-box {
  display: flex;
  align-items: center;
  gap: 8px;
  background: #FAEAEA;
  border: 1px solid #f5c6c6;
  border-radius: 8px;
  padding: 12px 16px;
  color: #D10000;
  font-family: Inter, sans-serif;
  font-size: 14px;
}

.automations-tab__error-icon {
  flex-shrink: 0;
  color: #D10000;
}

.automations-tab__retry {
  margin-left: auto;
  background: none;
  border: 1px solid #D10000;
  border-radius: 4px;
  color: #D10000;
  padding: 4px 12px;
  font-size: 12px;
  cursor: pointer;
}

.automations-tab__approvals-section {
  display: flex;
  flex-direction: column;
  gap: 12px;
  padding-bottom: 24px;
  border-bottom: 1px dashed #C4C4C4;
}

.automations-tab__approvals-header {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 0 4px;
}

.automations-tab__approvals-label {
  font-family: Inter, sans-serif;
  font-weight: 500;
  font-size: 14px;
  line-height: 20px;
  letter-spacing: 0.1px;
  color: #374957;
}

.automations-tab__approvals-count {
  font-family: Inter, sans-serif;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  letter-spacing: 0.25px;
  color: #666;
}

.automations-tab__approved-section {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.automations-tab__approved-header {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 0 4px;
}

.automations-tab__approved-label {
  font-family: Inter, sans-serif;
  font-weight: 500;
  font-size: 14px;
  line-height: 20px;
  letter-spacing: 0.1px;
  color: #374957;
}

.automations-tab__approved-count {
  font-family: Inter, sans-serif;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  letter-spacing: 0.25px;
  color: #666;
}

.automations-tab__active-section {
  display: flex;
  flex-direction: column;
  gap: 24px;
  padding-bottom: 24px;
  border-bottom: 1px dashed #C4C4C4;
}

.automations-tab__card-row {
  display: flex;
  gap: 24px;
  align-items: flex-start;
}

.automations-tab__card-spacer {
  flex: 1;
}

.automations-tab__completed-section {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.automations-tab__completed-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 4px;
}

.automations-tab__completed-title {
  display: flex;
  align-items: center;
  gap: 10px;
}

.automations-tab__completed-label {
  font-family: Inter, sans-serif;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  letter-spacing: 0.25px;
  color: #333;
}

.automations-tab__completed-sublabel {
  font-family: Inter, sans-serif;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  letter-spacing: 0.25px;
  color: #666;
}

.automations-tab__auto-archived {
  font-family: Inter, sans-serif;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  letter-spacing: 0.25px;
  color: #666;
}

/* Archive Dialog */
.archive-dialog {
  width: 100%;
}

.archive-dialog__header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  background-color: #faeaea;
  padding: 16px 24px;
}

.archive-dialog__header-content {
  display: flex;
  align-items: center;
  gap: 4px;
  flex: 1;
}

.archive-dialog__header-icon {
  width: 24px;
  height: 24px;
  flex-shrink: 0;
}

.archive-dialog__title {
  font-family: 'Inter', sans-serif;
  font-size: 20px;
  font-weight: 600;
  color: #d10000;
  margin: 0;
}

.archive-dialog__close-btn {
  background: transparent;
  border: none;
  cursor: pointer;
  padding: 0;
  width: 28px;
  height: 28px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.archive-dialog__content {
  display: flex;
  flex-direction: column;
  align-items: center;
  background-color: #f9fbfd;
  padding: 24px 32px;
}

.archive-dialog__message {
  font-family: 'Inter', sans-serif;
  font-size: 16px;
  font-weight: 400;
  color: #374957;
  line-height: 28px;
  margin: 0;
  text-align: center;
}

.archive-dialog__message strong {
  font-weight: 700;
}

.archive-dialog__footer {
  display: flex;
  flex-direction: column;
  background-color: #f9fbfd;
  padding: 0 24px 24px;
}

.archive-dialog__actions {
  display: flex;
  gap: 12px;
  justify-content: space-between;
  width: 100%;
  padding-top: 24px;
  border-top: 1px dashed #c4c4c4;
}

.archive-dialog__btn {
  height: 40px;
  padding: 8px 32px;
  border-radius: 4px;
  border: none;
  cursor: pointer;
  font-family: 'Inter', sans-serif;
  font-size: 14px;
  font-weight: 500;
  letter-spacing: 0.1px;
  white-space: nowrap;
  box-shadow: 0px 1px 3px 0px rgba(74, 74, 74, 0.25);
}

.archive-dialog__btn--cancel {
  background: white;
  border: 1px solid #d10000;
  color: #d10000;
}

.archive-dialog__btn--cancel:hover {
  background: #faeaea;
}

.archive-dialog__btn--confirm {
  background: #d10000;
  color: white;
}

.archive-dialog__btn--confirm:hover {
  background: #b00000;
}

.archive-dialog__btn--confirm:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.archive-dialog__btn--confirm:disabled:hover {
  background: #d10000;
}
</style>
